import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// NOTE: auth tokens live in HttpOnly cookies (set by the backend on login /
// register / refresh) and are sent automatically by axios via
// `withCredentials: true`. We deliberately avoid stashing the access token in
// localStorage (which would expose it to any XSS payload running on this
// origin). No Authorization header is attached client-side — the cookie is
// the single source of truth.

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Ocorreu um erro. Tente novamente.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.message === "string") return detail.message;
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);
